export default {
  methods: {
    handleErros(error) {
      const data = error?.response?.data;

      let msg = "";

      if (!data) {
        msg = "Algo aconteceu, erro não reconhecido!";
        return;
      }

      if (Array.isArray(data) && typeof data[0] == "string") {
        msg = data.join("\n");
      } else if (Array.isArray(data) && typeof data[0] == "object") {
        for (let k in data) {
          msg = Object.entries(data[k])
            .map(([_, v]) => v)
            .join("\n");
        }
      } else if (typeof data == "object") {
        msg = Object.entries(data)
          .map(([_, v]) => v)
          .join("\n");
      }

      this.$message.error(msg);
    },
  },
};
